import api from './api';

const getPhotos = async () => {
  const res = await api.get('/photobooth');
  return res.data;
};

const getSettings = async () => {
  const res = await api.get('/photobooth/settings');
  return res.data;
};

// Assign to a variable first
const photoboothService = {
  getPhotos,
  getSettings
};

// Export the variable
export default photoboothService;